import Vue from 'vue'
import './waves.css'

Vue.directive('waves', {
  bind(el, binding) {
    el.addEventListener('touchstart', e => {//click//touchstart//mousedown
      //console.log(e);
      const customOpts = Object.assign({}, binding.value)
      const opts = Object.assign({
        ele: el, // 波纹作用元素
        type: 'hit', // hit点击位置扩散center中心点扩展
        color: 'rgba(0, 0, 0, 0.15)' // 波纹颜色
      }, customOpts)
      const target = opts.ele
      if (target) {
        target.style.position = 'relative'
        target.style.overflow = 'hidden'
        const rect = target.getBoundingClientRect()
        let ripple = target.querySelector('.waves-ripple')
        if (!ripple) {
          ripple = document.createElement('span')
          ripple.className = 'waves-ripple'
          ripple.style.height = ripple.style.width = Math.max(rect.width, rect.height) + 'px'
          target.appendChild(ripple)
        } else {
          ripple.className = 'waves-ripple'
        }
        switch (opts.type) {
          case 'center':
            ripple.style.top = (rect.height / 2 - ripple.offsetHeight / 2) + 'px'
            ripple.style.left = (rect.width / 2 - ripple.offsetWidth / 2) + 'px'
            break
          default:
            var scrollPosTop;
            var scrollPosLeft;
            if ( typeof window.pageYOffset != 'undefined' ){
              scrollPosTop = window.pageYOffset; 
              scrollPosLeft = window.pageXOffset; 
            }
            else if ( typeof document.compatMode != 'undefined' && document.compatMode != 'BackCompat' ) {
              scrollPosTop = document.documentElement.scrollTop; 
              scrollPosLeft = document.documentElement.scrollLeft; 
            }
            else if ( typeof document.body != 'undefined' ) {
              scrollPosTop = document.body.scrollTop; 
              scrollPosLeft = document.body.scrollLeft; 
            }

            ripple.style.top = (e.touches[0].pageY - rect.top - ripple.offsetHeight / 2 - scrollPosTop) + 'px'
            ripple.style.left = (e.touches[0].pageX - rect.left - ripple.offsetWidth / 2 - scrollPosLeft) + 'px'
            //console.log(e.pageY, e.pageX, scrollPosLeft, ripple.style.left, rect.left);
        }

        ripple.style.backgroundColor = opts.color
        ripple.className = 'waves-ripple z-active'
        return false
      }
    }, false)
  }
});


// WEBPACK FOOTER //
// ./src/directive/waves/waves.js